import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { AssetFilter } from "../generated/gql/graphql";

type AssetFilterApi = {
  filter?: AssetFilter;
  setFilter(filter: AssetFilter | undefined): void;
};

export default function useAssetFilter(): AssetFilterApi {
  const [filter, setFilter] = useState<AssetFilter | undefined>();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const preloadFilter: Partial<AssetFilter> = {};

    const categoryId = searchParams.get("categoryId");
    if (categoryId) {
      preloadFilter.categoryId = {
        eq: categoryId,
      };
    }

    const name = searchParams.get("name");
    if (name) {
      preloadFilter.name = {
        icontains: name,
      };
    }

    const status = searchParams.get("status");
    if (status) {
      preloadFilter.status = {
        eq: status,
      };
    }

    const assetTypes = searchParams.get("assetTypes");
    if (assetTypes) {
      preloadFilter.assetTypes = {
        eq: assetTypes,
      };
    }

    const approval = searchParams.get("approval");
    if (approval) {
      preloadFilter.approval = {
        eq: approval,
      };
    }

    const metashotsType = searchParams.get("metashotsType");
    if (metashotsType) {
      preloadFilter.metashotsType = {
        eq: metashotsType,
      };
    }

    const languageRegionId = searchParams.get("languageRegionId");
    if (languageRegionId) {
      preloadFilter.languageRegionId = {
        eq: languageRegionId,
      };
    }

    setFilter(preloadFilter);
  }, []);

  return {
    filter,
    setFilter: (v) => setFilter(v),
  };
}
